import { useEffect } from 'react'
import { useLiveChatClicked, useLiveChatStarted, useLiveChatEnded } from '@/hooks/AnalyticsLiveChatHook'

export const AnalyticsLiveChatTracker: React.FC = () => {
  const trackLiveChatClicked = useLiveChatClicked()
  const trackLiveChatStarted = useLiveChatStarted()
  const trackLiveChatEnded = useLiveChatEnded()

  useEffect(() => {
    // 1. Delegated click handler for the Chat button
    const delegatedClickHandler = (e: MouseEvent) => {
      const target = (e.target as HTMLElement).closest('.helpButtonEnabled')
      if (target) {
        trackLiveChatClicked()
      }
    }
    document.addEventListener('click', delegatedClickHandler)

    // 2. Observe form and end-chat buttons
    const observer = new MutationObserver(() => {
      const startBtn = document.querySelector('.startButton')
      if (startBtn && !startBtn.hasAttribute('data-tracked')) {
        startBtn.setAttribute('data-tracked', 'true')
        startBtn.addEventListener('click', () => {
          const firstName = (document.querySelector('#FirstName') as HTMLInputElement)?.value
          const lastName = (document.querySelector('#LastName') as HTMLInputElement)?.value
          const email = (document.querySelector('#Email') as HTMLInputElement)?.value
          trackLiveChatStarted({ email, firstName, lastName })
        })
      }

      const endBtn = document.querySelector('.dialog-button-0')
      if (endBtn && !endBtn.hasAttribute('data-tracked')) {
        endBtn.setAttribute('data-tracked', 'true')
        endBtn.addEventListener('click', () => {
          trackLiveChatEnded()
        })
      }
    })
    observer.observe(document.body, { childList: true, subtree: true })

    // 3. Polling fallback to catch untracked chat endings
    let chatStarted = false
    const interval = setInterval(() => {
      const chatInput = document.querySelector('.embeddedServiceLiveAgentStateChatInput')
      if (chatInput && !chatStarted) {
        chatStarted = true
      } else if (!chatInput && chatStarted) {
        chatStarted = false
        trackLiveChatEnded()
      }
    }, 1000)

    return () => {
      document.removeEventListener('click', delegatedClickHandler)
      observer.disconnect()
      clearInterval(interval)
    }
  }, [])

  return null
}

export default AnalyticsLiveChatTracker
